/**
 * Global facility catalog search — `GET /v2/facilities/?search=`.
 *
 * Distinct from `endpoints/facilities.ts` (which is the per-submission
 * locations: `/v2/submissions/{id}/locations/`). This hits the shared
 * catalog the backend matches submission locations against. `search`
 * matches by CMS number OR facility name (Henry, jun-19). Used by the
 * Facility Schedule "Facility Name" autocomplete to pre-fill a row.
 */
import { getJsonReal } from "../client";

/** A catalog facility (`FacilityGet` on the backend). Only the fields the
 *  Schedule autocomplete reads/auto-fills are typed here. */
export interface CatalogFacility {
    id: string;
    name: string;
    address: string | null;
    city: string | null;
    state: string | null;
    zip_code: string | null;
    /** County is stored as a FIPS code (Henry: "county = fips"). */
    fips: string | null;
    /** "Urban" | "Rural" — maps to the Schedule Geo column. */
    urbanicity: string | null;
    cms_number: string | null;
    skilled_beds: number | null;
    skilled_beds_licensed: number | null;
    assisted_beds: number | null;
    assisted_beds_licensed: number | null;
    independent_beds: number | null;
    independent_beds_licensed: number | null;
}

export function searchFacilityCatalog(search: string, limit = 8): Promise<CatalogFacility[]> {
    const qs = new URLSearchParams({ search, limit: String(limit) });
    return getJsonReal<CatalogFacility[]>(`/v2/facilities/?${qs.toString()}`);
}
